import React from "react";

import ForgotPassword from "../../rows/ForgotPassword";
import HeaderWrapper from "../../header/header-wrapper";

const ForgotPasswordPage = () => (
  <React.Fragment>
    <HeaderWrapper hideTopAd={true} />

    <ForgotPassword />
  </React.Fragment>
);

export { ForgotPasswordPage };
